import seasonData from '../../../../config/static_data/seasons.json'
import { sortBy } from 'lodash'

export function getSeasonPeriodRange(
  period: number,
): { firstPeriod: number; lastPeriod?: number } | undefined {
  const seasons = sortBy(
    seasonData.filter((season) => typeof season.first_period_id === 'number'),
    'first_period_id',
  )

  let firstPeriod: number | undefined
  let lastPeriod: number | undefined

  for (let i = 0; i < seasons.length; i++) {
    if (seasons[i].first_period_id > period) break

    firstPeriod = seasons[i].first_period_id
    lastPeriod = seasons[i + 1] ? seasons[i + 1].first_period_id - 1 : undefined
  }

  if (firstPeriod === undefined) return undefined

  return { firstPeriod, lastPeriod }
}
